import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import reducer from './reducers'

const loggerMiddleware = createLogger()

export default function configureStore(preload) {
  return createStore(
    reducer,
    preload,
    applyMiddleware(
      thunkMiddleware,
      loggerMiddleware
    )
  )
}
